import { standardStringSchema, trimmedStringSchema, urlSchema } from "@/schemas"
import { z } from "zod"

export const editCredentialSchema = z.object({
  // Multiline operational notes routinely exceed defaultMaxLength.
  notes: trimmedStringSchema,
  // Utility vault secret: no max; do not use passwordSchema (min 12).
  password: trimmedStringSchema.min(1),
  username: standardStringSchema.min(1),
  website: urlSchema,
})

export type EditCredentialSchema = z.infer<typeof editCredentialSchema>
